import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import Loader from './components/Loader';
import store from './redux/store';

const LazzyApp = React.lazy(() => import('./App'));

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <Suspense fallback={<Loader />}>
      <React.StrictMode>
        <LazzyApp />
      </React.StrictMode>
    </Suspense>
  </Provider>,
);
